import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'absoluteNumber' })
export class AbsoluteNumberPipe implements PipeTransform {
	transform(value: any) {
		return value?.toString()?.replace(/[-]/g, '');
	}
}
